import React, { useContext } from "react";
import Skeleton from "./Skeleton";
import DataContext from "../../context/DataContext";

const AlbumListCardSkeleton = () => {
  const { centerWidth } = useContext(DataContext);
  const cardCount = centerWidth < 845 ? " 1 0 21%" : " 1 0 15%";
  return (
    <div style={{ flex: cardCount }}>
      <Skeleton classes={" h-36 mx-1 my-3 rounded-lg"} />
    </div>
  );
};

export default AlbumListCardSkeleton;
